import ResetConfirmation from "./ResetConfirmation.query";

export default ResetConfirmation;
